import React from 'react';
import type { AgendyAisAgendaDto } from '@gov-nx/api';
import { useAgendaSearchAutocomplete } from '@gov-nx/core/hooks';
import {
	LocalizeNameSpaceTypes,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import type { FormAutocompleteProps } from '../FormAutocomplete';
import { FormAutocomplete } from '../FormAutocomplete';

interface Props extends Omit<
	FormAutocompleteProps<AgendyAisAgendaDto>,
	'field'
> {
	field: Omit<
		FormAutocompleteProps<AgendyAisAgendaDto>['field'],
		'templateResolver' | 'keyResolver' | 'valueResolver' | 'searchCallback'
	>;
}

export const AgendaSearchAutocomplete = (props: Props) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(LocalizeNameSpaceTypes.Form);
	const { searchCallback } = useAgendaSearchAutocomplete('nazev');

	return (
		<FormAutocomplete<AgendyAisAgendaDto>
			label={props.label}
			field={{
				...props.field,
				messageEmpty:
					props.field.messageEmpty ?? tn('naseptavac.pole.zadny-vysledek'),
				templateResolver: (item) => `${item.kod} ${item.nazev}`,
				keyResolver: (item) => item.kod ?? '',
				valueResolver: (item) => `${item.kod} ${item.nazev}`,
				searchCallback,
			}}
		/>
	);
};
